/* eslint-disable no-undef */
/*
Copyright 2021 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import { TemplateView } from "../general/TemplateView";

export class MetaMaskLoginView extends TemplateView {
    render(t, vm) {
        // var disabled = (vm) => !!vm.isBusy;

        return t.div({ className: "MetaMaskLoginView form" }, [
            t.if(
                (vm) => vm.error,
                (t) => t.div({ className: "error" }, (vm) => vm.error)
            ),
            t.if(
                (vm) => vm.errorMessage,
                (t, vm) => t.p({ className: "error" }, vm.i18n(vm.errorMessage))
            ),
            t.div({
                onclick: (evnt) => {
                    evnt.preventDefault();
                    vm.metaMaskLogin();
                },
                className: "metaMask-btn",
            }),
        ]);
    }
}
